"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardCategory = void 0;
var qs = require('qs');
// [Standard Category]
exports.standardCategory = function (axios) {
    return {
        getStandardCategories: function (getStandardCategoriesRequest) {
            return axios.get('/standard-categories', getStandardCategoriesRequest);
        },
        getStandardCategoriesTree: function (getStandardCategoriesTreeRequest) {
            return axios.get('/standard-categories/tree', getStandardCategoriesTreeRequest);
        },
        getStandardCategoriesCommissions: function (getStandardCategoriesCommissionsRequest) {
            return axios.get('/standard-categories/commissions', getStandardCategoriesCommissionsRequest);
        },
        putStandardCategoriesCommissions: function (putStandardCategoriesCommissionsRequest) {
            return axios.put('/standard-categories/commissions', putStandardCategoriesCommissionsRequest.data);
        },
        getStandardCategoriesExcel: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/standard-categories/excel?" + query);
        }
    };
};
